import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

import { RestService } from './rest.service';

export interface StartVoterImportPayload {
  defaultLocalId: number | null;
  fileName: string;
  localId: number;
  rowCount: number;
}

@Injectable()
export class VoterImportService {
  constructor(private readonly rest: RestService) {}

  getImports(): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/voter-import`);
  }

  getImportOverview(): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/voter-import/!overview`);
  }

  getImportById(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/voter-import/${id}`);
  }

  getCurrentImportForLocal(localId: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/voter-import/!current?localId=${+localId}`);
  }

  getDeleteImportPreview(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/voter-import/${id}/!deletePreview`);
  }

  startImport(payload: StartVoterImportPayload): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/voter-import`, payload);
  }

  finishImport(id: number, rowCount: number, abandoned: boolean): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/voter-import/${id}/!finish`, {
      abandoned,
      rowCount,
    });
  }

  deleteImport(id: number): Promise<any> {
    return this.rest.delete(`${environment.apiUrl}/api/core/voter-import/${id}`);
  }

  restoreImport(id: number): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/voter-import/${id}/!restore`, {});
  }
}
